import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';
import { LandingComponent } from './landing/landing.component';
import { LoginComponent } from './login/login.component';
import { VooComponent } from './voo/voo.component';
import { OnibusComponent } from './onibus/onibus.component';

const routes: Routes =[
    { path: '', component: LandingComponent, data: {
        title: 'Indenização por problemas em viagens de avião ou ônibus.',
        description: 'Indenização por problemas em viagens de avião ou ônibus.'
    } },
    { path: 'voo', component: VooComponent, data: {
        title: 'Problemas com Voo | Help Passengers',
        description: 'Solicite indenização por cancelamento, atraso de voo, overbooking, no-show ou extravio de bagagem. Conheça seus direitos como passageiro aéreo.'
    } },
    { path: 'onibus', component: OnibusComponent, data: {
        title: 'Problemas com Ônibus | Help Passengers',
        description: 'Solicite indenização por atraso, falha mecânica, cancelamento ou extravio de bagagem em viagens de ônibus. Conheça seus direitos como passageiro.'
    } },
    { path: 'contato', component: SignupComponent, data: {
        title: 'Solicitar Atendimento | Help Passengers',
        description: 'Entre em contato com a Help Passengers pelo WhatsApp, Facebook Messenger ou e-mail e solicite sua indenização por problemas com voos ou ônibus.'
    } },
    { path: 'home', redirectTo: '', pathMatch: 'full' },
    { path: '**', redirectTo: '' }
];

// rotas
@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
